<template>
  <div>
    <HeroSection />
    <ProblemSection />
    <SolutionSection />
    <FounderStorySection />    
    <PricingSection />
    <FAQSection />
    <TrustSection />
    <FinalCTASection />
  </div>
</template>

<script>
import FAQSection from "@/components/FAQSection.vue";
import FinalCTASection from "@/components/FinalCTASection.vue";
import FounderStorySection from "@/components/FounderStorySection.vue";
import HeroSection from "@/components/HeroSection.vue";
import PricingSection from "@/components/PricingSection.vue";
import ProblemSection from "@/components/ProblemSection.vue";
import SolutionSection from "@/components/SolutionSection.vue";
import TrustSection from "@/components/TrustSection.vue";


export default {
  name: "HomeView",
  components: {
    HeroSection,
    ProblemSection,
    SolutionSection,
    FounderStorySection,
    PricingSection,
    FAQSection,
    TrustSection,
    FinalCTASection
  },
  mounted() {
    this.initScrollAnimations();
  },
  methods: {
    initScrollAnimations() {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
      
      // Observe all fade-in sections
      this.$nextTick(() => {
        document.querySelectorAll('.fade-in-section').forEach(section => {
          observer.observe(section);
        });
      });
    }
  }
}
</script>
